<template>
  <div class="wrapper">
    <!-- <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}"> -->
    <sidebar-fixed-toggle-button />
    <side-bar :background-color="backgroundColor">
      <!-- <mobile-menu slot="content"></mobile-menu> -->
      <template slot="links">
        <sidebar-link
          v-for="(menu, index) in topMenus"
          :key="index"
          :link="{
            name: menu.name,
            icon: menu.icon,
            path: menu.path,
          }"
        >
          <sidebar-link v-for="(l, i) in menu.link" :key="'A' + i" :link="{ name: l.name, path: l.path }" />
        </sidebar-link>

        <hr />

        <sidebar-link
          v-for="(menu, index) in bottomMenus"
          :key="'B' + index"
          :link="{
            name: menu.name,
            icon: menu.icon,
            path: menu.path,
          }"
        >
          <sidebar-link v-for="(l, i) in menu.link" :key="'C' + i" :link="{ name: l.name, path: l.path }" />
        </sidebar-link>
      </template>
    </side-bar>

    <div class="main-panel" :data="backgroundColor">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./DashboardContent.vue";
import SideBar from "@/components/SidebarPlugin/SideBar.vue";
import SidebarLink from "@/components/SidebarPlugin/SidebarLink.vue";
import SidebarFixedToggleButton from "./SidebarFixedToggleButton.vue";
import Env from "@/common/Env";

export default {
  async created() {
    this.backgroundColor = Env.isProduction() ? "red" : "blue";
    document.title = Env.isProduction() ? `${document.title}` : `${document.title} (staging)`;
    const result = await this.$axios.get(`/common/role`);
    const roles = result.data.data.split(",");
    this.topMenus = this.firstMenus.filter((menu) => menu.roles.some((r) => roles.includes(r)));
    this.bottomMenus = this.secondMenus.filter((menu) => menu.roles.some((r) => roles.includes(r)));
  },
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    SideBar,
    SidebarLink,
    SidebarFixedToggleButton,
  },
  data() {
    return {
      backgroundColor: "red",
      topMenus: [],
      bottomMenus: [],
      firstMenus: [
        {
          name: "투데이",
          icon: "tim-icons icon-chart-pie-36",
          path: "/today",
          link: [{ name: "투데이 관리", path: "/today/today" }],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "뷰어",
          icon: "tim-icons icon-chart-pie-36",
          path: "/viewer",
          link: [
            { name: "아티스트", path: "/viewer" },
            { name: "KPOP NOW", path: "/viewer/rank" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "스케줄",
          icon: "tim-icons icon-calendar-60",
          path: "/schedules",
          link: [
            { name: "스케줄", path: "/schedules/schedules" },
            { name: "인기 스케줄풀", path: "/schedules/hotSchedulePool" },
            { name: "스케줄 제보", path: "/schedules/scheduleSuggestion" },
            { name: "스케줄 알림 타입", path: "/schedules/scheduleNotificationType" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "불판",
          icon: "tim-icons icon-calendar-60",
          path: "/thread",
          link: [{ name: "불판 관리", path: "/thread" }],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "트렌드",
          icon: "tim-icons icon-wifi",
          path: "/radars",
          link: [
            { name: "트렌드 컨텐츠", path: "/radars/radarContents" },
            { name: "인기키워드 관리", path: "/labs/keywords" },
            { name: "키워드 설정", path: "/labs/artistKeywords" },
            { name: "아티스트 채널 관리", path: "/radars/artistChannelManage" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "팬로그",
          icon: "tim-icons icon-wifi",
          path: "/fanLog",
          link: [
            { name: "팬로그", path: "/fanLog/fanLogs" },
            { name: "인기 팬로그풀", path: "/fanLog/hotFanLogs" },
            { name: "인기 태그", path: "/fanLog/hotTags" },
            { name: "챌린지", path: "/fanLog/challenges" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "토픽",
          icon: "tim-icons el-icon-notebook-2",
          path: "/topic",
          link: [{ name: "토픽 컨텐츠", path: "/topic/contents" }],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "갤러리",
          icon: "tim-icons icon-badge",
          path: "/collection",
          link: [
            { name: "갤러리 컨텐츠", path: "/collection/collections" },
            { name: "인기갤러리 풀", path: "/collection/collectionPool" },
            { name: "갤러리 해시태그", path: "/collection/collectionHashTags" },
            { name: "갤러리 해시태그 관리", path: "/collection/collectionHashTagManage" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        // {
        //   name: "TMI",
        //   icon: "tim-icons el-icon-notebook-2",
        //   path: "/trivia",
        //   link: [{ name: "TMI 관리", path: "/trivia/triviaContents" }],
        //   roles: ["admin", "contentAdmin"],
        // },
        // {
        //   name: "잡담",
        //   icon: "tim-icons el-icon-notebook-2",
        //   path: "/chitchat",
        //   link: [{ name: "잡담 컨텐츠", path: "/chitchat/contents" }],
        //   roles: ["admin", "contentAdmin"],
        // },
        {
          name: "아티스트보드",
          icon: "tim-icons icon-single-02",
          path: "/artistBoard",
          link: [
            { name: "아티스트보드", path: "/artistBoard/artistBoard" },
            { name: "아티스트보드 제안", path: "/artistBoard/artistBoardSuggestion" },
            { name: "입덕갤러리", path: "/artistBoard/ipdokCollection" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "블립 아티스트",
          icon: "tim-icons icon-satisfied",
          path: "/blipArtist",
          link: [
            { name: "아티스트 관리", path: "/blipArtist/blipArtist" },
            { name: "아티스트 제안", path: "/blipArtist/blipArtistSuggestion" },
            { name: "아티스트 블랙키워드", path: "/blipArtist/blipArtistBlackKeyword" },
            { name: "아티스트 카테고리", path: "/blipArtist/blipArtistCategories" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "투표",
          icon: "tim-icons icon-coins",
          path: "/poll",
          link: [
            { name: "투표 관리", path: "/poll/list" },
            { name: "기본 템플릿", path: "/poll/default-template" },
            { name: "리워드 위젯 관리", path: "/poll/rewards" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "서포트 요청",
          icon: "tim-icons icon-bullet-list-67",
          path: "/fundingRequest",
          link: [{ name: "서포트 요청", path: "/fundingRequest/list" }],
          roles: ["admin", "contentAdmin"],
        },
        // {
        //   name: "불판관리",
        //   icon: "tim-icons icon-paper",
        //   path: "/thread",
        //   link: [
        //     { name: "불판관리", path: "/thread/thread" },
        //     { name: "금지단어설정", path: "/thread/threadBadKeyword" },
        //   ],
        //   roles: ["admin", "contentAdmin"],
        // },
        // {
        //   name: "마이페이지",
        //   icon: "tim-icons icon-paper",
        //   path: "/myPage",
        //   link: [{ name: "덕질기록", path: "/myPage/stanningLog" }],
        //   roles: ["admin", "contentAdmin"],
        // },
        {
          name: "배너/팝업관리",
          icon: "tim-icons icon-paper",
          path: "/banner",
          link: [
            { name: "이벤트 배너", path: "/banner/eventBanner" },
            { name: "아티스트 별 배너", path: "/banner/eventBannerGroup" },
            { name: "팝업", path: "/banner/popup" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "퀘스트 관리",
          icon: "tim-icons icon-paper",
          path: "/quest",
          link: [
            { name: "퀘스트관리", path: "/quest" },
            { name: "카테고리관리", path: "/quest/category" },
            { name: "웹페이지관리", path: "/quest/site" },
            { name: "홈미션관리", path: "/home/site" },
            { name: "포토카드관리", path: "/quest/photoCard" },
          ],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "이벤트관리",
          icon: "tim-icons icon-paper",
          path: "/event",
          link: [{ name: "친구추천", path: "/event/invitation" }],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "언어별메세지관리",
          icon: "tim-icons icon-paper",
          path: "/language",
          roles: ["admin", "languageAdmin"],
        },
        {
          name: "퀵코멘트 관리",
          icon: "tim-icons icon-paper",
          path: "/comment/quickComments",
          roles: ["admin", "languageAdmin"],
        },
        {
          name: "알림",
          icon: "tim-icons icon-paper",
          path: "/notification",
          link: [
            { name: "알림문구관리", path: "/notification/template" },
            { name: "알림전송", path: "/notification/customNotification" },
            { name: "채팅전송", path: "/notification/customChatNotification" },
            { name: "예약알림관리", path: "/notification/reservedNotification" },
          ],
          roles: ["admin"],
        },
        {
          name: "홈페이지 관리",
          icon: "tim-icons icon-paper",
          path: "/homepage",
          link: [
            { name: "홈페이지 관리", path: "/homepage" },
            { name: "공유페이지 관리", path: "/homepage/sharePage" },
            { name: "배너 관리", path: "/homepage/banner" },
            { name: "사이트 관리", path: "/homepage/sites" },
            { name: "커뮤니티 관리", path: "/homepage/community" },
          ],
          roles: ["admin"],
        },
        {
          name: "템플릿 관리",
          icon: "tim-icons icon-paper",
          path: "/template",
          roles: ["admin"],
        },
      ],
      secondMenus: [
        {
          name: "유저관리",
          icon: "tim-icons icon-notes",
          path: "/user",
          link: [
            { name: "유저 관리", path: "/user/userManage" },
            { name: "닉네임 블랙리스트", path: "/user/nickname/blackList" },
          ],
          roles: ["admin"],
        },
        {
          name: "고객센터",
          icon: "tim-icons icon-notes",
          path: "/notices",
          link: [
            { name: "공지사항", path: "/notices/notice" },
            { name: "FAQ", path: "/faqs/faq" },
            { name: "1:1 고객문의", path: "/inqueries/inquery" },
          ],
          roles: ["admin"],
        },
        {
          name: "약관/방침 관리",
          icon: "tim-icons icon-notes",
          path: "/terms",
          link: [{ name: "약관/방침 목록", path: "/terms/list" }],
          roles: ["admin"],
        },
        { name: "신고", icon: "tim-icons icon-alert-circle-exc", path: "/reports", roles: ["admin"] },
        {
          name: "댓글",
          icon: "tim-icons el-icon-chat-dot-round",
          path: "/comment",
          link: [{ name: "댓글 조회", path: "/comment/contents" }],
          roles: ["admin", "contentAdmin"],
        },
        {
          name: "운영자관리",
          icon: "tim-icons el-icon-chat-dot-round",
          path: "/comment",
          link: [{ name: "운영자 관리", path: "/adminUser/adminUserManage" }],
          roles: ["admin"],
        },
        {
          name: "파일관리",
          icon: "tim-icons icon-notes",
          path: "/fileManage",
          link: [{ name: "앱 파일관리", path: "/fileManage/appFile" }],
          roles: ["admin"],
        },
        {
          name: "결제",
          icon: "tim-icons icon-notes",
          path: "/payment",
          link: [{ name: "구독관리", path: "/payment/subscription" }],
          roles: ["admin"],
        },
      ],
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
